import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  facilities: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
}

export const facilitiesSlice = createSlice({
  name: 'facilities',
  initialState: initialState,
  reducers: {
    setFacility: (state, { payload }) => {
      state.facilities = payload?.data ?? payload;
      state.total = payload?.total || 0;
      state.last_page = payload?.last_page || 1;
      state.current_page = payload?.current_page || 1;
      state.per_page = payload?.per_page || PAGELENGTH;
    },
    setFacilities: (state, { payload }) => {
      state.facilities = payload?.data?.data || [];
      state.total = payload?.data?.total || 0;
      state.is_more = payload?.data?.is_more || false;
      state.last_page = payload?.data?.last_page || 1;
      state.current_page = payload?.data?.current_page || 1;
      state.per_page = payload?.data?.per_page || PAGELENGTH;
    },
    setMoreFacilities: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    removeFacility: (state, { payload }) => {
      state.error = payload
    },
    clearAllFacility: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})


export const addFacility = (data, callback, disableLoader) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  !disableLoader && dispatch(setLoader(true))
  try {

    const json = await Api.addFacility(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setFacility(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  !disableLoader && dispatch(setLoader(false))
}

export const updateFacility = (data, itemId, callback, disableLoader) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  !disableLoader && dispatch(setLoader(true))
  try {

    const json = await Api.updateFacility(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setFacility(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  !disableLoader && dispatch(setLoader(true))
}

export const removeFacility = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeFacility(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setFacility(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}
export const fetchFacilities = (page, params, disableLoader, Aync) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchFacilities(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setFacilities(result.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        } else {
          console.log(result.data.data?.data, "abcd")
          dispatch(setFacilities(result.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }
  } catch (error) {
    console.log("error", error)
  }
}


export const changeStatus = (id, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const json = await Api.statusChange(id, data, "subclients/types/facilities")
    if (json.status >= 200 && json.status < 300) {
    } else if (json.status == 422) {
      dispatch(setError(json.data))
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}

export const removeMultipleFacilities = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeMultipleFacilities(ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setHospital(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const { setFacility, setFacilities, clearAllFacility, setLoader, setError, setMoreFacilities } = facilitiesSlice.actions


export default facilitiesSlice.reducer
export const facilitiesSelector = state => state.facilities


